import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601 } from '../../../../../../utils';

import {
  getRelationTypeDisplay,
  PendingCustomerRelationRequestView,
  UnmatchedLinkRequestLog
} from '../../../../../../models/customer';

import { AccountService } from '../../../../../../services/account/account.service';
import { CustomerService } from '../../../../../../services/customer/customer.service';

import {
  ReviewPendingLinkedAccountModalComponent
} from '../../../customers/customer-detail/modals/review-pending-linked-account-modal/review-pending-linked-account-modal.component';

@Component({
  selector: 'app-inbox-linking-account-requests',
  templateUrl: './inbox-linking-account-requests.component.html',
  styleUrls: ['./inbox-linking-account-requests.component.css']
})
export class InboxLinkingAccountRequestsComponent implements OnInit {

  public relationRequests: PendingCustomerRelationRequestView[];
  public unmatchedLinkRequestLogs: UnmatchedLinkRequestLog[];

  public loadingRelationRequests = false;
  public loadingUnmatchedLinkRequestLogs = false;

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getRelationTypeDisplay = getRelationTypeDisplay;
  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public accountService: AccountService,
    private customerService: CustomerService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadRelationRequests();
    this.loadUnmatchedLinkRequestLogs();
  }

  public relationRequestsPresent() {
    return this.relationRequests && (this.relationRequests.length > 0);
  }

  public unmatchedLinkRequestLogsPresent() {
    return this.unmatchedLinkRequestLogs && (this.unmatchedLinkRequestLogs.length > 0);
  }

  public openReviewPendingLinkedAccountModal(relationRequest: PendingCustomerRelationRequestView) {
    const modalRef = this.modalService.open(ReviewPendingLinkedAccountModalComponent);
    modalRef.componentInstance.relationRequest = relationRequest;
    modalRef.componentInstance.showHideOption = true;
    modalRef.componentInstance.savedCallback = () => {
      this.loadRelationRequests();
    };
  }

  private loadRelationRequests() {
    this.loadingRelationRequests = true;

    this.customerService
      .getOrgPendingCustomerRelations()
      .then(relationRequests => {
        this.relationRequests = relationRequests;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRelationRequests = false; });
  }

  private loadUnmatchedLinkRequestLogs() {
    this.loadingUnmatchedLinkRequestLogs = true;

    this.customerService
      .getOrgUnmatchedLinkRequestLogs()
      .then(result => {
        this.unmatchedLinkRequestLogs = result;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingUnmatchedLinkRequestLogs = false; });
  }

}
